import React from 'react';
import { Button, Skeleton } from 'antd';

interface EPButtonProps {
  showSkeleton?: boolean;
  children?: JSX.Element | string;
  [x: string]: unknown;
}

const EPButton = React.forwardRef(
  ({ children, showSkeleton, ...rest }: EPButtonProps, ref: React.Ref<HTMLButtonElement | HTMLAnchorElement>) => {
    return showSkeleton ? (
      <Skeleton.Button active size="large" style={{ width: 140 }} />
    ) : (
      <Button size="large" ref={ref} {...rest}>
        {children}
      </Button>
    );
  },
);

export default EPButton;
